import DeleteConsultingCompanyContainer from "./DeleteContingencyContainer";
export default DeleteConsultingCompanyContainer;
